import { goalbookUrls } from '@/links'

export { postUserLogin, postOneTimeCodeRequest, postOneTimeCodeVerify, postTermsAccepted }

async function postUserLogin(email, password, token) {
  const response = await fetch(`${goalbookUrls.accounts}/api/users/signin`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams({
      email,
      password,
      source: 'toolkit',
      ref: 'login_modal',
      authenticity_token: token,
    }).toString(),
  })
  if (!response.ok) {
    let message = 'There was a problem with your login request.'
    try {
      const body = await response.json()
      if (body.message) message = body.message
    } catch { /* use default message */ }
    throw new Error(message)
  }
  return response.json()
}

async function postOneTimeCodeRequest(email, token) {
  const response = await fetch(`${goalbookUrls.auth}/onetimecode/request`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRF-Token': token,
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams({ email, authenticity_token: token, dest: 'toolkit' }).toString(),
  })
  if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
}

async function postOneTimeCodeVerify(email, code, token) {
  const response = await fetch(`${goalbookUrls.auth}/onetimecode/verify`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRF-Token': token,
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams({ email, code, authenticity_token: token, dest: 'toolkit', relogin: 'true' }).toString(),
  })
  if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
}

async function postTermsAccepted() {
  const response = await fetch(`${goalbookUrls.toolkit}/terms_accepted`, {
    method: 'POST',
    credentials: 'include',
  })
  if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
  return response.json()
}
